import { Box, ButtonBase, useTheme } from "@mui/material";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import { useEffect, useState } from "react";
import { useGetShippersSelectWithProfilesQuery } from "../../../newapi/shipper/shipperSlice";
import { getShipperColorSettingsByType } from "../../Streams/StreamShipperSettings";
import Text from "../../theme/text/Text";
import { DropdownBase } from "../../theme/dropdowns/Dropdown";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { yupNumberRequired } from "../../../utils/validation";
import * as yup from "yup";
import { useUpdateOrderMutation } from "../../../newapi/order/ordersSlice";
import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../utils/toasts";

const MUpdateOrderShipper = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [fieldErrors, setFieldErrors] = useState({});
    const [updateOrder,{isLoading}] = useUpdateOrderMutation();

    const rules = {
        shipperId: yupNumberRequired("shipper",t,true),
        shipperProfileId: yupNumberRequired("shipperprofile",t,true),
    };
    const schema = yup.object().shape(rules);

    const { data: shippers, isLoading: isLoadingShippers, isFetching: isFetchingShippers } = useGetShippersSelectWithProfilesQuery(
        {
            warehouseId: props.warehouseId, 
            includeBol: true
        },
        {
            skip: !props.warehouseId
        }
    );

    const [selectedShipper, setSelectedShipper] = useState(null);
    const [selectedShipperProfile, setSelectedShipperProfile] = useState(null);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const selectShipper = (selected) => {
        var shipper = shippers?.filter(shipper => shipper.type !== 'bol' || props.webshopcredentials?.webshop_type === 'bol')[selected];
        setSelectedShipper(shipper);
        setSelectedShipperProfile(-1);
        setFieldErrors(err => ({
            ...err,
            shipperId:''
        }))
    }

    const selectShipperProfile = (selected) => {
        var shipperProfile = selectedShipper?.shipperProfiles.find(option => option.id === selected);
        if(shipperProfile){
            setSelectedShipperProfile(shipperProfile);
            setFieldErrors(err => ({
                ...err,
                shipperProfileId:''
            }))
        }
    }
    useEffect(() => {
        if(!isLoadingShippers && !isFetchingShippers && shippers && props.shipper) {
            var shipper = shippers.find((shipper) => shipper.id === props.shipper.id);
            setSelectedShipper(shipper);
            if(props.shipperProfile) {
                var shipperProfile = shipper?.shipperProfiles.find((profile) => profile.id === props.shipperProfile.id);
                setSelectedShipperProfile(shipperProfile);
            }
        
        }
    }, [props.shipper,props.shipperProfile,shippers,isLoadingShippers, isFetchingShippers])

    // useEffect(() => {
    //     if(props.shipper) {
    //         setSelectedShipper(props.shipper);
    //     }
    //     if(props.shipperProfile) {
    //         setSelectedShipperProfile(props.shipperProfile);
    //     }
    // }, [props.shipper,props.shipperProfile])


    const SaveOrder = async () => {
        try {
            setFieldErrors({});
            await schema.validate({
                shipperId: selectedShipper.id,
                shipperProfileId:selectedShipperProfile.id,
            }, { abortEarly: false });
            const data = await updateOrder({
                id: props.orderId,
                shipperId: selectedShipper.id,
                shipperProfileId:selectedShipperProfile.id,
            }).unwrap()
            showToastMessageUpdateRequest(t, data);

            props.handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                    ...acc,
                    [currentError.path]: currentError.message
                }), {});
                
                setFieldErrors(errors);
            } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
            }
        }
    };

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("update_shipper")}</Subheading>
            </Box>

            <Box 
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    paddingRight:3,
                    paddingLeft:3,
                    paddingTop:3,
                    paddingBottom:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    alignItems:"center",
                    gap:1
                }}
            >
                <Box
                    sx={{
                        minHeight:120,
                        position:'sticky',
                        top:0,
                        borderRadius:4,
                        p:1.5,
                        flex:1,
                        boxShadow:`0px 2px 4px ${ (fieldErrors.shipperId || fieldErrors.shipperProfileId) ? colors.red[300] : getShipperColorSettingsByType(selectedShipper?.type).streamrulehover}`,
                        border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]}`,
                        background: (fieldErrors.shipperId || fieldErrors.shipperProfileId) ? colors.red[100] : getShipperColorSettingsByType(selectedShipper?.type).background,
                        transition: 'background-color 0.5s',
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"flex-end",
                            justifyContent:'space-between',
                        }}
                    >
                        
                        <Box>
                            <Text color={tokens("white").txt["primary"]}>{t("shipper")}:</Text><br/>
                            <Text color={fieldErrors.shipperId ? colors.red[400] : getShipperColorSettingsByType(selectedShipper?.type).base} bold>{selectedShipper?.name ?? t("no_selection")}</Text>
                        </Box> 
                        <ButtonBase
                            sx={{
                                ml:2,
                                width:32,
                                height:32,
                                background: fieldErrors.shipperId ? colors.red[400] : getShipperColorSettingsByType(selectedShipper?.type).base,
                                color: fieldErrors.shipperId ? theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"] : getShipperColorSettingsByType(selectedShipper?.type).background,
                                borderRadius:5,
                            }}
                        >
                            <DropdownBase
                                key={selectedShipper?.id}
                                transformOrigin={{
                                    vertical: "bottom"
                                }}
                                anchorOrigin={{
                                    vertical:"top"
                                }}
                                displayName={"name"} 
                                onChange={(selected) => {
                                    selectShipper(selected);
                                }}
                                // valueKey={"id"}
                                disallowDeselection
                                noSelection={""} 
                                options={shippers?.filter(shipper => shipper.type !== 'bol' || props.webshopcredentials?.webshop_type === 'bol')}
                                selected={shippers?.filter(shipper => shipper.type !== 'bol' || props.webshopcredentials?.webshop_type === 'bol').findIndex(shipper => shipper.id === selectedShipper?.id) ?? -1}
                                closeOnSelection
                                searchOptions={{
                                    enabled:true,
                                    placeholder:t("search")
                                }}
                            >
                                <EditOutlinedIcon/>
                            </DropdownBase>
                        </ButtonBase>
                        
                    </Box>
                    
                    <Box
                        sx={{
                            mt:2,
                            display:"flex",
                            justifyContent:'space-between',
                            alignItems:'flex-end',
                        }}
                    >
                        <Box>
                            <Text color={tokens("white").txt["primary"]}>{t("shipperprofile")}:</Text><br/>
                            <Text color={fieldErrors.shipperProfileId ? colors.red[400] : getShipperColorSettingsByType(selectedShipper?.type).base} bold>{selectedShipperProfile?.name ?? t("no_selection")}</Text>
                                
                        </Box>
                        <ButtonBase
                            sx={{
                                width:32,
                                height:32,
                                background:fieldErrors.shipperProfileId ? colors.red[400] : getShipperColorSettingsByType(selectedShipper?.type).base,
                                color:fieldErrors.shipperProfileId ? theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"] : getShipperColorSettingsByType(selectedShipper?.type).background,
                                borderRadius:5,
                            }}
                        >
                            <DropdownBase
                                key={selectedShipperProfile?.id}
                                transformOrigin={{
                                    vertical: "bottom"
                                }}
                                anchorOrigin={{
                                    vertical:"top"
                                }}
                                displayName={"name"} 
                                onChange={(selected) => {
                                    selectShipperProfile(selected)
                                }}
                                noSelection={""}
                                options={selectedShipper?.shipperProfiles}
                                selected={selectedShipperProfile?.id ?? -1}
                                closeOnSelection
                                searchOptions={{
                                    enabled:true,
                                    placeholder:t("search")
                                }}
                                valueKey={"id"}
                            >
                                <EditOutlinedIcon/>
                            </DropdownBase>
                        </ButtonBase>
                    </Box>
                </Box>
                
            </Box>
                
            
            <Box
                component="footer"
                sx={{
                    pt:2,
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton 
                isCancel={true} 
                className={"always-visible"} 
                onClick={props.handleClose} 
                color="primary" 
                variant="text" 
                startIcon={<ArrowRightAltIcon/>}
                >
                    {t("cancel")}
                </Shbutton>
                <ButtonGroup version={2}> 
                    <Shbutton 
                    isLoading={isLoading} 
                    className={"group-btn"} 
                    color={"green"}
                    variant="contained" 
                    onClick={SaveOrder}
                    >{t("update")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MUpdateOrderShipper;